/* MotoWing ürün sayfası: satıcı kartı + paylaş, WhatsApp ile sipariş, beden rehberi. Ayarlar ilgili öğelerin data-* özniteliklerinden okunur. */
(function(){
  var SE=document.querySelector('[data-mwr-sel]'); if(!SE) return;
  var H=SE.getAttribute('data-h'), ID=+SE.getAttribute('data-id'), U=SE.getAttribute('data-u'), T=SE.getAttribute('data-t');
  /* "Sana Özel" rafı için ürün kimliği */
  try{ var m=JSON.parse(localStorage.getItem('mw_rvid')||'{}'); if(!m||typeof m!=='object') m={}; delete m[H]; m[H]=ID; var ks=Object.keys(m); while(ks.length>40){ delete m[ks.shift()]; } localStorage.setItem('mw_rvid',JSON.stringify(m)); }catch(e){}
  /* Mağaza şu an açık mı (İstanbul = UTC+3 sabit) */
  try{
    var o=document.querySelector('[data-mwr-sel-open]'), h=new Date(Date.now()+108e5).getUTCHours();
    if(o){ var on=h>=9&&h<22; o.textContent=on?'Mağaza şu an açık':'Mağaza şu an kapalı · 09:00\'da açılır'; o.classList.toggle('is-on',on); o.hidden=false; }
  }catch(e){}
  /* Paylaş */
  var sh=document.querySelector('[data-mwr-shr]'); if(!sh) return;
  document.body.appendChild(sh);
  var pn=sh.querySelector('.mwr-shr__p'), inp=sh.querySelector('[data-mwr-shr-u]'), cp=sh.querySelector('.mwr-shr__u [data-ch="copy"]'), nat=sh.querySelector('[data-ch="native"]'), back=null;
  if(navigator.share&&nat) nat.hidden=false;
  function link(ch){
    var v=''; try{ v=new URLSearchParams(location.search).get('variant')||''; }catch(e){}
    var q=(v&&/^\d+$/.test(v)?'variant='+v+'&':'')+'utm_source=paylas'+(ch?'&utm_medium='+ch:'');
    return U+'?'+q;
  }
  function msg(){ return 'MotoWing\'de bu ürüne bak: '+T; }
  function open(btn){
    back=btn||document.activeElement; inp.value=link('kopyala');
    sh.hidden=false; document.documentElement.style.overflow='hidden';
    setTimeout(function(){ var x=sh.querySelector('.mwr-shr__x'); if(x) x.focus(); },30);
  }
  function close(){
    sh.hidden=true; document.documentElement.style.overflow='';
    cp.textContent='Kopyala'; cp.classList.remove('is-ok');
    if(back&&back.focus) back.focus();
  }
  function copy(){
    var s=link('kopyala'), done=function(){ cp.textContent='Kopyalandı'; cp.classList.add('is-ok'); };
    if(navigator.clipboard&&window.isSecureContext){ navigator.clipboard.writeText(s).then(done,function(){ inp.select(); try{ document.execCommand('copy'); done(); }catch(e){} }); }
    else { inp.value=s; inp.select(); try{ document.execCommand('copy'); done(); }catch(e){} }
  }
  sh.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-mwr-shr-x]')){ close(); return; }
    var a=t.closest('[data-ch]'); if(!a) return;
    var ch=a.getAttribute('data-ch'), u=encodeURIComponent(link(ch)), m=encodeURIComponent(msg());
    if(ch==='copy'){ copy(); return; }
    if(ch==='native'){ navigator.share({title:T,text:msg(),url:link('cihaz')}).catch(function(){}); return; }
    var href={
      whatsapp:'https://wa.me/?text='+m+'%20'+u,
      telegram:'https://t.me/share/url?url='+u+'&text='+m,
      facebook:'https://www.facebook.com/sharer/sharer.php?u='+u,
      x:'https://twitter.com/intent/tweet?text='+m+'&url='+u,
      email:'mailto:?subject='+encodeURIComponent(T)+'&body='+m+'%0A%0A'+u
    }[ch];
    if(href) a.setAttribute('href',href);
  });
  inp.addEventListener('focus',function(){ inp.select(); });
  document.addEventListener('keydown',function(e){
    if(sh.hidden) return;
    if(e.key==='Escape'){ close(); return; }
    if(e.key==='Tab'){
      var f=[].slice.call(pn.querySelectorAll('a[href],button:not([hidden]),input')).filter(function(x){ return x.getClientRects().length; });
      if(!f.length) return; var a=f[0], z=f[f.length-1];
      if(e.shiftKey&&document.activeElement===a){ e.preventDefault(); z.focus(); }
      else if(!e.shiftKey&&document.activeElement===z){ e.preventDefault(); a.focus(); }
    }
  });
  /* Başlığa paylaş butonu (kalbin solunda) */
  var IC='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="18" cy="5" r="2.6"/><circle cx="6" cy="12" r="2.6"/><circle cx="18" cy="19" r="2.6"/><path d="m8.3 13.3 7.4 4.4M15.7 6.3l-7.4 4.4"/></svg>';
  function addBtn(){
    if(document.querySelector('.mwr-shb')) return;
    var t=document.querySelector('.product__info-container div.product__title'); if(!t) return;
    var b=document.createElement('button'); b.type='button'; b.className='mwr-shb'; b.setAttribute('aria-label','Ürünü paylaş'); b.innerHTML=IC;
    t.classList.add('mwr-shr-on'); t.appendChild(b);
  }
  document.addEventListener('click',function(e){ var b=e.target.closest&&e.target.closest('.mwr-shb,[data-mwr-shr-open]'); if(!b) return; e.preventDefault(); open(b); });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',addBtn); else addBtn();
})();
(function(){
  var sh=document.querySelector('[data-mwr-wos]'); if(!sh) return;
  var V={}; try{ V=JSON.parse(sh.querySelector('[data-mwr-wo-v]').textContent)||{}; }catch(e){ return; }
  document.body.appendChild(sh);
  var T=sh.getAttribute('data-t'), U=sh.getAttribute('data-u'), MF=sh.getAttribute('data-mf')||'', ITH=sh.getAttribute('data-ith')==='1', V0=sh.getAttribute('data-v0');
  var pn=sh.querySelector('.mwr-wos__p'), qi=sh.querySelector('[data-mwr-wo-qi]'), msg=sh.querySelector('[data-mwr-wo-msg]'), nm=sh.querySelector('[data-mwr-wo-n]'), ct=sh.querySelector('[data-mwr-wo-c]'), cf=sh.querySelector('[data-mwr-wo-cf]'), nt=sh.querySelector('[data-mwr-wo-x]'), back=null, vid=V0;
  function money(c){
    c=Number(c)||0; var m=/\{\{\s*(\w+)\s*\}\}/.exec(MF||''), k=m?m[1]:'amount';
    function f(d,t,s){ var p=(c/100).toFixed(d).split('.'); p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,t); return p.join(s); }
    var v=k==='amount_no_decimals'?f(0,',','.'):k==='amount_with_comma_separator'?f(2,'.',','):k==='amount_no_decimals_with_comma_separator'?f(0,'.',','):f(2,',','.');
    return m?MF.replace(m[0],v):v+' TL';
  }
  function curVar(){
    var i=document.querySelector('product-info form[action*="/cart/add"] input[name="id"]')||document.querySelector('form[action*="/cart/add"][id^="product-form"] input[name="id"]');
    var id=i&&i.value?i.value:V0; return V[id]?id:V0;
  }
  function curQty(){ var q=document.querySelector('product-info input[name="quantity"]'); var n=q?parseInt(q.value,10):1; return n>0?Math.min(n,20):1; }
  function dlv(){ var r=sh.querySelector('input[name="mwr-wo-d"]:checked'); return r?r.value:'kargo'; }
  function calc(){
    var v=V[vid], q=Math.max(1,Math.min(20,parseInt(qi.value,10)||1)), sub=v.p*q, d=dlv(), s;
    if(d==='magaza') s=0; else if(ITH) s=1050000; else s=sub>=700000?0:40000;
    return {v:v,q:q,sub:sub,s:s,tot:sub+s,d:d};
  }
  function draw(){
    var c=calc(), vv=sh.querySelector('[data-mwr-wo-var]'), sd=sh.querySelector('[data-mwr-wo-sh]');
    vv.textContent=c.v.t==='Default Title'?'':c.v.t+(c.v.a?'':' · şu an stokta yok');
    sh.querySelector('[data-mwr-wo-pr]').textContent=money(c.v.p);
    sh.querySelector('[data-mwr-wo-sub]').textContent=(c.q>1?c.q+' × '+money(c.v.p)+' = ':'')+money(c.sub);
    sd.textContent=c.d==='magaza'?'Mağazadan teslim · ücretsiz':(c.s?money(c.s):'Ücretsiz'); sd.classList.toggle('is-g',!c.s);
    sh.querySelector('[data-mwr-wo-tot]').textContent=money(c.tot);
    if(cf) cf.hidden=c.d==='magaza';
  }
  function open(b){
    back=b||document.activeElement; vid=curVar(); qi.value=curQty(); msg.hidden=true; nm.classList.remove('is-bad'); draw();
    sh.hidden=false; document.documentElement.style.overflow='hidden';
    setTimeout(function(){ try{ pn.focus({preventScroll:true}); }catch(e){} },30);
  }
  function close(){ sh.hidden=true; document.documentElement.style.overflow=''; if(back&&back.focus){ try{ back.focus({preventScroll:true}); }catch(e){} } }
  function send(){
    var c=calc(), n=nm.value.trim();
    if(!n){ msg.textContent='Siparişin için adını ve soyadını yaz.'; msg.hidden=false; nm.classList.add('is-bad'); nm.focus(); return; }
    var L=['Merhaba, WhatsApp üzerinden sipariş vermek istiyorum.','Ürün: '+T];
    if(c.v.t!=='Default Title') L.push('Seçenek: '+c.v.t);
    L.push('Adet: '+c.q);
    L.push('Ürün tutarı: '+(c.q>1?c.q+' × '+money(c.v.p)+' = ':'')+money(c.sub));
    L.push('Teslimat: '+(c.d==='magaza'?'Mağazadan teslim (Konya)':'Kargo ile ('+(c.s?money(c.s):'ücretsiz')+')'));
    L.push('Toplam: '+money(c.tot));
    L.push('Ad soyad: '+n);
    if(c.d!=='magaza'&&ct.value.trim()) L.push('İl / ilçe: '+ct.value.trim());
    if(nt.value.trim()) L.push('Not: '+nt.value.trim());
    L.push(U+'?variant='+vid);
    window.open('https://wa.me/905016050642?text='+encodeURIComponent(L.join('\n')),'_blank','noopener');
  }
  document.addEventListener('click',function(e){ var b=e.target.closest&&e.target.closest('[data-mwr-wo-open]'); if(!b) return; e.preventDefault(); open(b); });
  sh.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-mwr-wos-x]')){ close(); return; }
    var q=t.closest('[data-mwr-wo-q]');
    if(q){ qi.value=Math.max(1,Math.min(20,(parseInt(qi.value,10)||1)+(+q.getAttribute('data-mwr-wo-q')))); draw(); return; }
    if(t.closest('[data-mwr-wo-go]')) send();
  });
  sh.addEventListener('change',draw);
  qi.addEventListener('input',draw);
  nm.addEventListener('input',function(){ if(nm.value.trim()){ nm.classList.remove('is-bad'); msg.hidden=true; } });
  document.addEventListener('keydown',function(e){
    if(sh.hidden) return;
    if(e.key==='Escape'){ close(); return; }
    if(e.key==='Tab'){
      var f=[].slice.call(pn.querySelectorAll('button,input')).filter(function(x){ return x.getClientRects().length&&!x.disabled; });
      if(!f.length) return; var a=f[0], z=f[f.length-1];
      if(e.shiftKey&&(document.activeElement===a||document.activeElement===pn)){ e.preventDefault(); z.focus(); }
      else if(!e.shiftKey&&document.activeElement===z){ e.preventDefault(); a.focus(); }
    }
  });
})();
(function(){
  var sh=document.querySelector('[data-mwr-sz]'); if(!sh) return;
  var V={}; try{ V=JSON.parse(sh.querySelector('[data-mwr-sz-v]').textContent)||{}; }catch(e){}
  document.body.appendChild(sh);
  var T=sh.getAttribute('data-t'), ML=sh.getAttribute('data-ml')||'Ölçün';
  var pn=sh.querySelector('.mwr-sz__p'), mi=sh.querySelector('[data-mwr-sz-m]'), bi=sh.querySelector('[data-mwr-sz-b]'), ki=sh.querySelector('[data-mwr-sz-k]'), msg=sh.querySelector('[data-mwr-sz-msg]'), back=null;
  function open(b){ back=b||document.activeElement; sh.hidden=false; document.documentElement.style.overflow='hidden'; setTimeout(function(){ try{ pn.focus({preventScroll:true}); }catch(e){} },30); }
  function close(){ sh.hidden=true; document.documentElement.style.overflow=''; if(back&&back.focus){ try{ back.focus({preventScroll:true}); }catch(e){} } }
  function vt(){ var i=document.querySelector('product-info form[action*="/cart/add"] input[name="id"]')||document.querySelector('form[action*="/cart/add"][id^="product-form"] input[name="id"]'); var t=i&&V[i.value]; return t&&t!=='Default Title'?t:''; }
  function send(){
    var m=(mi.value||'').replace(',','.').trim();
    if(!m||isNaN(+m)){ msg.hidden=false; mi.classList.add('is-bad'); mi.focus(); return; }
    var L=['Merhaba, '+T+' için beden danışmak istiyorum.',ML.replace(/n$/,'m')+': '+m+' cm'];
    if(bi&&bi.value) L.push('Boy: '+bi.value+' cm'); if(ki&&ki.value) L.push('Kilo: '+ki.value+' kg');
    var v=vt(); if(v) L.push('Baktığım seçenek: '+v);
    L.push(location.origin+location.pathname);
    window.open('https://wa.me/905016050642?text='+encodeURIComponent(L.join('\n')),'_blank','noopener');
  }
  document.addEventListener('click',function(e){ var b=e.target.closest&&e.target.closest('[data-mwr-sz-open]'); if(!b) return; e.preventDefault(); open(b); });
  sh.addEventListener('click',function(e){ if(e.target.closest('[data-mwr-sz-x]')){ close(); return; } if(e.target.closest('[data-mwr-sz-wa]')) send(); });
  mi.addEventListener('input',function(){ if(mi.value){ msg.hidden=true; mi.classList.remove('is-bad'); } });
  document.addEventListener('keydown',function(e){
    if(sh.hidden) return;
    if(e.key==='Escape'){ close(); return; }
    if(e.key==='Tab'){
      var f=[].slice.call(pn.querySelectorAll('a[href],button,input')).filter(function(x){ return x.getClientRects().length; });
      if(!f.length) return; var a=f[0], z=f[f.length-1];
      if(e.shiftKey&&(document.activeElement===a||document.activeElement===pn)){ e.preventDefault(); z.focus(); }
      else if(!e.shiftKey&&document.activeElement===z){ e.preventDefault(); a.focus(); }
    }
  });
})();
